/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DuplicatePlaceholderAllocationInput = {|
  id?: ?string,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type duplicatePlaceholderAllocationMutationVariables = {|
  input: DuplicatePlaceholderAllocationInput
|};
export type duplicatePlaceholderAllocationMutationResponse = {|
  +duplicatePlaceholderAllocation: ?{|
    +placeholderAllocation: ?{|
      +node: ?{|
        +id: string,
        +startDate: ?string,
        +endDate: ?string,
        +monday: ?number,
        +tuesday: ?number,
        +wednesday: ?number,
        +thursday: ?number,
        +friday: ?number,
        +saturday: ?number,
        +sunday: ?number,
        +description: ?string,
        +placeholder: ?{|
          +id: string
        |},
      |}
    |}
  |}
|};
export type duplicatePlaceholderAllocationMutation = {|
  variables: duplicatePlaceholderAllocationMutationVariables,
  response: duplicatePlaceholderAllocationMutationResponse,
|};
*/


/*
mutation duplicatePlaceholderAllocationMutation(
  $input: DuplicatePlaceholderAllocationInput!
) {
  duplicatePlaceholderAllocation(input: $input) {
    placeholderAllocation {
      node {
        id
        startDate
        endDate
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
        description
        placeholder {
          id
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DuplicatePlaceholderAllocationInput!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DuplicatePlaceholderAllocationPayload",
    "kind": "LinkedField",
    "name": "duplicatePlaceholderAllocation",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PlaceholderAllocationTypeEdge",
        "kind": "LinkedField",
        "name": "placeholderAllocation",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PlaceholderAllocation",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "monday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "tuesday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "wednesday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "thursday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "friday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "saturday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sunday",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Placeholder",
                "kind": "LinkedField",
                "name": "placeholder",
                "plural": false,
                "selections": [
                  (v1/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "duplicatePlaceholderAllocationMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "duplicatePlaceholderAllocationMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "duplicatePlaceholderAllocationMutation",
    "operationKind": "mutation",
    "text": "mutation duplicatePlaceholderAllocationMutation(\n  $input: DuplicatePlaceholderAllocationInput!\n) {\n  duplicatePlaceholderAllocation(input: $input) {\n    placeholderAllocation {\n      node {\n        id\n        startDate\n        endDate\n        monday\n        tuesday\n        wednesday\n        thursday\n        friday\n        saturday\n        sunday\n        description\n        placeholder {\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'dfacd25a23ebf9be0ddd45025828ca19';

module.exports = node;
